import { useEffect } from "react";
import { Flex, Spinner } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useApp } from "src/components/App/Context";
import { synchronizeCloudAccount } from "src/modules/auth/duck/epics";
import { redeemHotelTabletOffer } from "src/modules/purchase/ajax/cloud";
import { hasPremium } from "src/modules/auth/duck/selectors";
import { useSelector, useDispatch } from "react-redux";
import { H2 } from "src/atoms/typography";

const log = window.require("electron-log");

export default function Redeeming({ flow, closeWizard }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isPremium = useSelector(hasPremium);
  const app = useApp();

  useEffect(() => {
    async function redeemPromotion() {
      const { hotelName, tabletProvider } = flow.state.promo || {};
      try {
        await redeemHotelTabletOffer({ hotelName, tabletProvider });
        await dispatch(synchronizeCloudAccount());
        app.synchronizer.announceItemChange(
          app.synchronizer.SynchronizableItems.CLOUD_ACCOUNT
        );
      } catch (err) {
        log.error(err);
        navigate("/dashboard");
        closeWizard();
        return;
      }
      flow.push("redeem-success");
      return;
    }

    if (isPremium) {
      navigate("/dashboard");
      closeWizard();
      return;
    }

    redeemPromotion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      width="320px"
      mx="auto"
      height="100%"
    >
      <H2 color="highEmphasis" mb="24px">
        {t("wizard.redeemingOffer")}
      </H2>

      <Spinner size="lg" />
    </Flex>
  );
}
